import { axios } from '@/plugins/axios';
import { download } from '@/utils/fileDownload';
import { DocumentType } from '../../constants/api';
import { endPoints, Params } from '../types/api';
import { buildResultPublicationDocument } from '../types/entities/ResultPublicationDocument';
import { useNotification } from './useNotification';

export const useResultDocument = (type: DocumentType) => {
  const { showNotification } = useNotification();
  const publish_type = type === 'PRODUCTION' ? 1 : 2;

  const getResultPublicationDocument = async () => {
    return await axios
      .get(endPoints.getResultPublicationDocument.endPoint, {
        params: { publish_type },
      })
      .then((res) => {
        const resultDocument = buildResultPublicationDocument(res.data.items);

        return resultDocument;
      });
  };

  // VuexのactionsはPromiseを返さないのでaxiosを使用する
  const saveResultDocument = (
    payload: Params<'saveResultPublicationDocument'>,
  ) => {
    return axios
      .post(endPoints.saveResultPublicationDocument.endPoint, payload, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      })
      .then((res) => {
        showNotification({
          isShow: true,
          message: 'ファイルを登録しました',
          type: 'success',
        });

        return res;
      });
  };

  const downloadResultPublicationDocument = async () => {
    return axios
      .get(endPoints.downloadResultPublicationDocument.endPoint, {
        params: {
          publish_types: publish_type,
        },
        responseType: 'blob',
      })
      .then(download);
  };

  return {
    getResultPublicationDocument,
    saveResultDocument,
    downloadResultPublicationDocument,
  };
};
